import React, { useEffect, useState, useRef } from "react";
import "./ScrollableChipComp.scss"
import CloseIcon from "../../images/Close-Small-Chip.svg"
import LeftArrow from "../../images/chip-arrow-left.svg";
import RightArrow from "../../images/chip-arrow-right.svg";
import PrimaryButtonOutline from "./PrimaryChipButton";

const ScrollableChipComp = ({
  filterDataToDisplay,
  deleteFilterOption,
  resetAll,
  handleReset,
  fetchAllTemplates,
  getSearchedTemplates,
  search,
values,
setValues,
setSearchText,
  searchText,
  setnobannerFound,
  noData,
  setGenericInfo,
  genericInfo,
  isSearchBarEmpty,
  setIsSearchBarEmpty
}) => {
 
  const [showRightArrowButton, setShowRightArrowButton] = useState(false);
  const [showLeftArrowButton, setShowLeftArrowButton] = useState(false);
  const scrollContainerRef = useRef(null);
    useEffect(() => {
    const scrollContainer = document.querySelector(".scroll-container");

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      setShowLeftArrowButton(scrollLeft > 0);
      setShowRightArrowButton(scrollWidth - clientWidth > scrollLeft+1);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check
    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [filterDataToDisplay]);
  const leftScroll = () => {
    const container = scrollContainerRef.current;
    container.scrollBy({
      left: -100,
      behavior: "smooth",
    });
  };

  const rightScroll = () => {
    const container = scrollContainerRef.current;
    container.scrollBy({
      left: 100,
      behavior: "smooth",
    });
  };
  
  return (
    <>
      <div className={`${showLeftArrowButton ? "arrow-navigation" : ""}`}>
        {showLeftArrowButton && (
          <img src={LeftArrow} alt="" style={{cursor:"pointer"}} onClick={leftScroll} />
        )}
      </div>
      <div
        className="scroll-container"
       // id="scroll-container"
        ref={scrollContainerRef}
      >
        { filterDataToDisplay?.map((item, index) => (
          <div key={index} className="custom-chip">
            <span>{item.name || item}</span>
            <img
              src={CloseIcon}
              alt=""
              className="close-icon"
              onClick={(e) =>{handleReset(item, filterDataToDisplay.length>1?"remove":"reset")}}
            />
          </div>
        ))}
        {filterDataToDisplay.length > 0 &&
          !showRightArrowButton &&
          !showLeftArrowButton && (
            <PrimaryButtonOutline
              title={`Reset All`}
              handleClick={() => {
                handleReset("","reset");
              }}
              btnType="outline"
              showIcon={false}
              height={32}
            />
          )}
      </div>
      <div
        className={`${showRightArrowButton ? "arrow-navigation-right" : ""}`} //
      >
        {showRightArrowButton && (
          <img src={RightArrow} alt="" style={{cursor:"pointer", width:16, height:16}} onClick={rightScroll} />
        )}
      </div>
      {(showRightArrowButton || showLeftArrowButton) && (
        <div className="resetl-all">
          <PrimaryButtonOutline
            title={`Reset All`}
            handleClick={() => {
              handleReset("","reset");
            }}
            btnType="outline"
            showIcon={false}
            height={32}
          />
        </div>
      )}
    </>
  );
};
export default ScrollableChipComp;
